module.exports = __webpack_public_path__ + "img/Kh.25fb133f.png";